import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductAddPage } from './product-add.page';

const routes: Routes = [
  {
    path: '',
    component: ProductAddPage
  },
  {
    path: 'setting-add',
    loadChildren: () => import('./setting-add/setting-add.module').then(m => m.SettingAddPageModule)
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductAddPageRoutingModule {}
